"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardDateHeadersOption')(function discardDateHeadersOption(state) {
    var optionState = state.optionState;
    optionState.isEnabled = null;
}));
//# sourceMappingURL=discardDateHeadersOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-date-headers-option/lib/actions/discardDateHeadersOption.js
// module id = 5085
// module chunks = 2